/**
 * Leaving the tournament — the old full-width page's own "back" (old
 * `handleTournamentPlayBack`, then M4's `pages/tournament/model.ts
 * tournamentPageHandleBack`). Fix G, 2026-10-06 moved it here, standalone, once
 * the page it belonged to was deleted: the tournament is the ordinary Stage +
 * Rail now (`rail/Rail/model.ts selectRailMode`), so there is no adapter model
 * left to own it, but the exit itself is unchanged — leave the socket's
 * tournament ROOM (old `sendStopWatchingTournament` L413-421 — without it the
 * socket stays subscribed and the next tournament's broadcasts arrive
 * alongside this one's) and drop the context, which is what takes
 * `selectRailState` back to 'home' and resets the platform arena store.
 * `Body` puts the lobby back up in place.
 *
 * Fix N (owner, 2026-10-06): "if it's returning from a tournament keep the
 * Tournaments tab selected on the home" — `useLobby.getState().setTab(
 * 'tournaments')` (the raw `pages/home/lobbyStore.ts` setter; a CALL into
 * mirrored core, no edit there) — and "wherever the user came from, /playChess
 * or /CCTournaments, let it stay there": fix G's exit always navigated to
 * 'PlayChess' when the browser happened to be on `/CCTournaments`
 * (path-sniffed off `window.location`), which is what put the lobby under
 * `/CCTournaments?…` with the drawer's "Tournaments" item highlighted even
 * when the tournament had been opened from the Play tab (owner screenshot
 * 2026-10-06). This now clears the tournament params on `currentRoute()` —
 * THIS screen's own route name, read once at the root (`rail/navigateRef.ts`)
 * — instead of hard-navigating anywhere, so the URL and the sidebar stay on
 * whichever route the player is actually on, and a reload no longer re-enters
 * the tournament (its params are gone from the URL). Nothing navigates when
 * the route is unknown (no root mounted — the design lab, a stale ref after
 * unmount). `PLAY_ROUTE` / `TOURNAMENTS_PATH` / `routeProbe` /
 * `onTournamentsRoute` (the old path-sniffing) are gone with it.
 *
 * `chrome/useBackAction.ts` imports this directly (rather than calling a hook)
 * so the Play header's back control and the Details tab's own "leave" (G3) run
 * the IDENTICAL exit — a second copy of these two steps is exactly the kind of
 * drift P1-3 already burned this codebase on once.
 *
 * The old page also reset its own tab to 'games' here; that tab no longer
 * exists (`useV2Ui.tournamentTab` was removed in the same fix, G1) — the rail's
 * tab (`railTab`) is left alone, because `tabSpec.ts`'s `activeTab` already
 * falls back to Moves the moment the tournament panels stop being offered, and
 * the NEXT tournament entered picks its own default tab (G2).
 */
import {liveGameStore} from '@/Store/liveGameStore';

import {useLobby} from '../../pages/home/lobbyStore';
import {currentRoute, navigateTo} from '../navigateRef';

export function leaveTournament(): void {
  const {tournament, actions} = liveGameStore.getState();
  if (!tournament.id) {
    return;
  }
  actions.stopWatchingTournament();
  actions.setTournamentContext({id: null});
  useLobby.getState().setTab('tournaments');
  const route = currentRoute();
  if (route) {
    navigateTo(route, {
      tournamentId: undefined,
      isJoined: undefined,
      query: undefined,
    });
  }
}

export default leaveTournament;
